/* eslint-disable react-hooks/rules-of-hooks */
import generatingGif from "../../assets/generate-content.gif";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,  
  FormControlLabel,
  Link,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import StepOneForm from "../../components/stepsOfOnboard/StepOneForm";
import StepTwoForm from "../../components/stepsOfOnboard/StepTwoForm";
import StepThreeForm from "../../components/stepsOfOnboard/StepThreeForm";
import useSnack from "../../hooks/useSnack";
import { useFirstVisitRedirect } from "../../services/userFirstRedirect";
import Loading from "../../components/Loading";
import { FacebookTwoTone } from "@mui/icons-material";
import { setCookie } from "../../utilities/cookies";
import axios from "axios";
import { FcGoogle } from "react-icons/fc";
import { signInWithPopup, signOut } from "firebase/auth";
import {
  auth,
  facebookProvider,
  googleProvider,
} from "../../utilities/firebase.config";

const API_BASE_URL = "https://accounts.clikkle.com:5000/api";

const CombinedOnboarding = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const { SnackBar, showMessage } = useSnack();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const userIdFromParam = searchParams.get("userId");
  const redirectTo = decodeURIComponent(searchParams.get("redirectTo") || "/dashboard");

  async function HandleUserLoginById(userId) {
    try {
      // 1) Get the user profile
      const profileRes = await axios.post(
        "https://accounts.clikkle.com:5000/api/auth/get_user_profile",
        { id: userId }
      );
      const profileData = profileRes.data;
      if (!profileData?.user) {
        throw new Error("No user returned from profile API");
      }

      // Save profile to localStorage
      localStorage.setItem("user", JSON.stringify(profileData.user));

      setCookie("userId", profileData.user._id);
      setCookie("fullName", profileData.user.username);
      setCookie("role", profileData.user.role);
      showMessage({ success: "Login successful!" });
    } catch (err) {
      console.error("Error in handleUserLoginById:", err);
    }
  }

  const { userId, loadinggg, user: userProfile } = useFirstVisitRedirect();

  useEffect(() => {
    if (userIdFromParam) {
      HandleUserLoginById(userIdFromParam);
    }
  }, [userIdFromParam]);

  if (loadinggg) {
    return <Loading />;
  }

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      setEmailError(true);
      showMessage({ error: "Please enter a valid email address" });
      return;
    }

    try {
      setLoading(true);
      setEmailError(false);
      const userData = { recovery_email: email.trim() };
      localStorage.setItem("userData", JSON.stringify(userData));
      setOpen(true);
      showMessage({ success: "Email verified successfully!" });
    } catch (error) {
      showMessage({ error: "Failed to save email. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (step < 3) {
      setStep(step + 1);
    } else {
      setOpen(false);
      setLoading(true);
      setTimeout(() => {
        navigate(`/login?redirectTo=${encodeURIComponent(redirectTo)}`);
      }, 2000);
    }
  };

  const [loadding, setLoadding] = useState(false);

  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
  const [tokens, setTokens] = useState(null);

  const handleSocialLogin = async (provider) => {
    setLoadding(true);
    setError("");

    try {
      let result;
      let providerName;

      if (provider === "google") {
        result = await signInWithPopup(auth, googleProvider);
        providerName = "google";
      } else if (provider === "facebook") {
        result = await signInWithPopup(auth, facebookProvider);
        providerName = "facebook";
      } else {
        throw new Error("Invalid provider");
      }

      const idToken = await result.user.getIdToken();

      const response = await fetch(`${API_BASE_URL}/auth/socialLogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idToken,
          provider: providerName,
          login_app: "Clikkle Creator",
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Social login failed");
      }

      if (data.success) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("sessionToken", data.sessionToken);
        localStorage.setItem("user", JSON.stringify(data.user));

        setTokens({
          token: data.token,
          refreshToken: data.refreshToken,
          sessionToken: data.sessionToken,
        });
        setUser(data.user);
        showMessage({ success: "Login successful!" });
        data.sourceUrl = window.location.origin;
        const json = JSON.stringify(data);
        const encoded = btoa(json);
        const target = new URL("https://accounts.clikkle.com/other-apps/");
        target.searchParams.set("user", encoded);
        window.location.href = target.toString();
      }
    } catch (error) {
      console.error("Social login error:", error);
      setError(error.message || "An error occurred during login");
      showMessage({ error: error.message });

      try {
        await signOut(auth);
      } catch (signOutError) {
        console.error("Sign out error:", signOutError);
      }
    } finally {
      setLoadding(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {/* LEFT: Form */}
      <Container
        maxWidth="sm"
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh", // Full height of the page
          py: 6,
        }}
      >
        {loading ? (
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress />
            <Typography mt={2}>Redirecting to dashboard...</Typography>
          </Box>
        ) : (
          <>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Try Clikkle Creator <span>free</span>
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              No credit card required
            </Typography>

            {/* Social Login Buttons */}
            <div className="flex flex-col gap-4 w-full mt-4 mx-auto">
              <button type="button" onClick={() => handleSocialLogin("google")} disabled={loadding}
                className="w-full flex items-center justify-center py-2 md:py-3 px-3 md:px-4 border rounded-full shadow-sm text-sm font-medium">
                <FcGoogle className="h-4 w-4 md:h-5 md:w-5 mr-4" /> Continue with Google
              </button>

              <button type="button" onClick={() => handleSocialLogin("facebook")} disabled={loadding}
                className="w-full flex items-center justify-center py-2 md:py-3 px-3 md:px-4 border rounded-full shadow-sm text-sm font-medium">
                <FacebookTwoTone className="h-4 w-4 md:h-5 md:w-5 mr-4 text-[#1877f2]" /> Continue with Facebook
              </button>
            </div>

            <div className="my-4 flex items-center w-full mx-auto">
              <div className="flex-grow border-t"></div>
              <span className="flex-shrink mx-3 text-xs text-gray-500">OR</span>
              <div className="flex-grow border-t"></div>
            </div>

            {/* Email Form */}
            <Box component="form" onSubmit={handleEmailSubmit} sx={{ mt: 4 }}>
              <TextField
                fullWidth label="Email" required value={email} onChange={(e) => setEmail(e.target.value)}
                error={emailError}
                helperText={emailError ? "Please enter a valid email address" : ""}
                sx={{ mb: 2 }}
              />

              <FormControlLabel
                control={<Checkbox />}
                label={
                  <Typography variant="body2">
                    I agree to receive marketing emails from Clikkle Creator
                  </Typography>
                }
              />

              <Button type="submit" fullWidth disabled={loading} variant="contained"
                sx={{ bgcolor: "#0080FF", fontWeight: "bold", py: 1.2 }}
              >
                {loading ? <CircularProgress size={24} /> : "Get Started"}
              </Button>

              <Typography variant="body2" sx={{ mt: 2 }}>
                Already have an account?{" "}
                <Link component="button" onClick={() => navigate(`/login?redirectTo=${encodeURIComponent(redirectTo)}`)}>
                  Log In
                </Link>
              </Typography>
            </Box>
          </>
        )}

        {/* Onboarding Modal */}
        <Modal open={open} onClose={() => setOpen(false)} closeAfterTransition>
          <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
            {step === 1 && (<StepOneForm firstName={firstName} lastName={lastName} phone={phone}
              setFirstName={setFirstName} setLastName={setLastName} setPhone={setPhone} handleNext={handleNext} />)}
            {step === 2 && <StepTwoForm handleNext={handleNext} />}
            {step === 3 && <StepThreeForm email={email} setEmail={setEmail} handleNext={handleNext} />}
            {SnackBar}
          </Box>
        </Modal>
      </Container>
    </Box>
  );
};

export default CombinedOnboarding;
